import { Phone } from "lucide-react";

const FloatingCall = () => (
  <a
    href="tel:+14035055078"
    aria-label="Call Me 1st Fitness & Coaching at (403) 505-5078"
    data-testid="floating-call-btn"
    className="fixed bottom-5 right-5 z-50 md:hidden w-14 h-14 rounded-full bg-brand text-charcoal flex items-center justify-center shadow-[0_10px_30px_rgb(136,206,172,0.5)]"
  >
    <span className="absolute inset-0 rounded-full bg-brand animate-ping opacity-30" aria-hidden="true" />
    <Phone size={22} className="relative" />
  </a>
);

export default FloatingCall;
